var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(0 0)",
    fill: "#83a77a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,1A17,17,0,0,0,5.979,30.021,17,17,0,0,0,30.021,5.979,16.889,16.889,0,0,0,18,1m0-1A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.345,0A2.668,2.668,0,0,1,8.478,1.035h0L9.27,2.088a1.327,1.327,0,0,0,1.035.5h2.763C16.389,2.592,18.009,4.365,18,8h0v4.383C18,15.858,15.858,18,12.375,18H5.616C2.151,18,0,15.858,0,12.375H0V5.616C0,1.89,1.656,0,4.923,0H6.345Zm6.822,10.611H4.833a.675.675,0,1,0,0,1.35h8.334a.675.675,0,0,0,0-1.35Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.f1786d0e4261915f2bdcb499ccf8f394.svg";
export { ForwardRef as ReactComponent };